export function getLocalStorage(): Storage | undefined {
  try {
    return window.localStorage;
  } catch (error) {
    console.warn('Could not access local storage', error);
    return undefined;
  }
}
